
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { ApiResponse } from '../models/api-response.model';
import { DDCustomer, UpdateCustomerSubscriptionsModel } from '../models/customer.model';
import { Router } from '@angular/router';

@Injectable()
export class CustomerService {

  public refetchCustomerList$: Subject<void> = new Subject<void>();

  private currentCustomerList: DDCustomer[] = [] as DDCustomer[];
  private customerListSubject = new BehaviorSubject<DDCustomer[]>(this.currentCustomerList);
  public currentCustomerListWatch = this.customerListSubject.asObservable();
  public monitorCustomerList(list: DDCustomer[]): void {
    this.customerListSubject.next(list);
  }

  private currentCustomer: DDCustomer = {} as DDCustomer;
  private customerSubject = new BehaviorSubject<DDCustomer>(this.currentCustomer);
  public currentCustomerWatch = this.customerSubject.asObservable();
  public monitorCustomer(c: DDCustomer): void {
    this.customerSubject.next(c);
  }

  private currentCustomerPrograms: UpdateCustomerSubscriptionsModel[] = [] as UpdateCustomerSubscriptionsModel[];
  private customerProgramsSubject = new BehaviorSubject<UpdateCustomerSubscriptionsModel[]>(this.currentCustomerPrograms);
  public refetchCustomerPrograms$: Subject<void> = new Subject<void>();
  public currentCustomerProgramsWatch = this.customerProgramsSubject.asObservable();
  public monitorCustomerPrograms(list: UpdateCustomerSubscriptionsModel[]): void {
    this.customerProgramsSubject.next(list);
  }
  

  constructor(
    private http: HttpClient
    , private authService: AuthService
    , private router: Router
  ) {

  }

  public backToCustomerEnrollProgramPage(): void {
    this.currentCustomerWatch.pipe(first()).subscribe((res: DDCustomer) => { 
        this.router.navigateByUrl("/customers/" + res?.id  + "/enroll-program");
        $('#levelOne').animate({ scrollLeft: $('#manage-customer').width() + 250 }, 400);
    });
  }

  public getCustomers(customerId?: string): Observable<DDCustomer[]> {
    return this.http.get<DDCustomer[]>('Manage/GetCustomers' + (customerId ? `?customerId=${customerId}` : ''))
      .pipe(catchError(this.authService.handleError))
  }
  
  public createOrUpdateCustomer(model: DDCustomer): Observable<DDCustomer | ApiResponse> {  
    return this.http.post<DDCustomer | ApiResponse>('Manage/CreateOrUpdateCustomer', model)
      .pipe(catchError(this.authService.handleError));
  }

  public getSubscriptionProgramsByCustomerId(customerId: string): Observable<UpdateCustomerSubscriptionsModel[]> {  
    return this.http.get<UpdateCustomerSubscriptionsModel[]>('Manage/GetSubscriptionProgramsByCustomerId?customerId=' + customerId)
      .pipe(catchError(this.authService.handleError));      
  }

  public updateCustomerSubscriptions(inputModel: UpdateCustomerSubscriptionsModel): Observable<ApiResponse> {  
    return this.http.post<ApiResponse>('Manage/UpdateCustomerSubscriptions', inputModel)
      .pipe(catchError(this.authService.handleError));      
  }
}